import { Link } from '@revolut-internal/ui-kit'
import { ComponentPropsWithoutRef } from 'react'

export function renderMarkdownAnchor(props: ComponentPropsWithoutRef<'a'>) {
  const { children, href } = props

  return (
    <Link href={href} target="_blank">
      {children}
    </Link>
  )
}
